import React from "react";
import "./Pie.css";

const Pie = () => {
    return (
        <footer className="footer">
            <div className="footer-content">
                <div className="footer-prompt">
                    <span className="footer-user">javif</span>
                    <span className="footer-at">@</span>
                    <span className="footer-host">portfolio</span>
                    <span className="footer-sep">:</span>
                    <span className="footer-path">~</span>
                    <span className="footer-sym">❯</span>
                    <span className="footer-cmd"> echo "© 2024 Javi Fiallos — Built with React"</span>
                </div>
                <div className="footer-output">
                    <span className="footer-copy">© 2024 Javi Fiallos</span>
                    <span className="footer-sep-dot">·</span>
                    <span className="footer-built">Built with React</span>
                    <span className="footer-sep-dot">·</span>
                    <span className="footer-license">MIT License</span>
                </div>
            </div>
        </footer>
    );
};

export default Pie;